import type { AnyShippingMethod } from "@jti/commerce";
import type { AddressCustomShippingFieldValue, ShippingFormFields } from "@jti/commerce-types";
import type { Address, FlotiqInStoreDeliveryStore } from "@jti/fe-common";

const emptyMandatoryParameters = {
  firstname: "",
  lastname: "",
  streetName: "",
  streetNumber: "",
  streetAdditional: "",
  telephone: "",
};

export const fromInStoreToMainAddress = (flotiqAddress: FlotiqInStoreDeliveryStore): Address => ({
  ...flotiqAddress,
  ...emptyMandatoryParameters,
  city: flotiqAddress?.City || "",
  countryCode: flotiqAddress?.Country || "",
  postcode: flotiqAddress?.ZipCode || "",
  streetName: flotiqAddress?.Street || "",
  countryName: flotiqAddress?.Country || "",
  telephone: flotiqAddress?.PhoneNumber || "",
});

export const fromCustomToMainAddress = (customAddress: AddressCustomShippingFieldValue): Address => ({
  ...emptyMandatoryParameters,
  ...customAddress,
  postcode: customAddress?.postCode || "",
  city: customAddress?.city || "",
  countryCode: customAddress?.countryCode || "",
});

export const getShippingAddressByShippingMethodType = (
  shippingMethodType: AnyShippingMethod["type"] | undefined,
  checkoutData?: Partial<ShippingFormFields> | null
): Address | undefined => {
  if (!shippingMethodType || !checkoutData) {
    return undefined;
  }

  if (shippingMethodType === "atHome" && checkoutData.addressHomeDelivery) {
    return checkoutData?.addressHomeDelivery;
  }

  if (shippingMethodType === "custom delivery" && checkoutData.addressCustomShipping) {
    return fromCustomToMainAddress(checkoutData.addressCustomShipping);
  }

  if (shippingMethodType === "in-store delivery" && checkoutData.addressInStoreDelivery) {
    return fromInStoreToMainAddress(checkoutData.addressInStoreDelivery);
  }

  return undefined;
};
